import React from "react";

import Panel from "../panels/Panel";
import {
    Alignment,
    FlexBehaviour,
    FlexDirection,
    Side,
    Size,
} from "../../types/system/Layout";
import IconStyles from "../../types/enums/IconStyles";
import Button from "../buttons/Button";
import AcademicTerm from "../../types/core/AcademicTerm";

import "./TermDates.scss";
import PanelHeader from "../panels/PanelHeader";
import GeneralContainer from "../containers/GeneralContainer";
import ButtonThemes from "../../types/enums/ButtonThemes";
import AcademicTermRange from "../../types/core/AcademicTermRange";

interface TermDatesProps {
    value: AcademicTerm;
    className?: string;

    onEditRange?: (range: AcademicTermRange) => void;
    onRemoveRange?: () => void;
}

interface TermDatesState {}

class TermDates extends React.Component<TermDatesProps, TermDatesState> {
    render(): React.ReactNode {
        let classNames = "term-dates";

        if (this.props.className) classNames += ` ${this.props.className}`;

        return (
            <Panel
                className={classNames}
                bufferSide={Side.All}
                bufferSize={Size.Small}>
                <PanelHeader>
                    <h3>{this.props.value.display}</h3>

                    <Button
                        icon="close"
                        iconStyle={IconStyles.Red}
                        inline={true}
                        align={Alignment.Right}
                        tooltip="Remove these term dates"
                        tooltipPlace="right"
                        onClick={this.props.onRemoveRange}
                    />
                </PanelHeader>

                <GeneralContainer
                    flex={FlexDirection.Row}
                    flexSpaced={true}
                    clearanceSide={Side.Top}
                    clearanceSize={Size.Small}>
                    {this.props.value.ranges.map((semester, index) =>
                        semester.children.length ? (
                            <GeneralContainer
                                key={index}
                                flex={FlexDirection.Row}
                                flexSpaced={true}
                                flexBehaviour={FlexBehaviour.Max}
                                flexWrapped={true}>
                                {semester.children.map((term, childIndex) => (
                                    <Button
                                        key={childIndex}
                                        dialer={true}
                                        heightSize={Size.Small}
                                        bufferSide={Side.All}
                                        bufferSize={Size.Small}
                                        flexBehaviour={FlexBehaviour.Max}
                                        text={`${
                                            term.name
                                        }: ${term.startDate.toLocaleShortDate()} - ${term.endDate.toLocaleShortDate()}`}
                                        tooltip={`Click to edit dates${
                                            term.error
                                                ? ", these dates overlap with the previous range"
                                                : ""
                                        }`}
                                        theme={
                                            term.error
                                                ? ButtonThemes.Bad
                                                : ButtonThemes.Normal
                                        }
                                        onClick={() =>
                                            this.props.onEditRange?.(term)
                                        }
                                    />
                                ))}
                            </GeneralContainer>
                        ) : (
                            <Button
                                dialer={true}
                                heightSize={Size.Small}
                                bufferSide={Side.All}
                                bufferSize={Size.Small}
                                flexBehaviour={FlexBehaviour.Max}
                                text={`${
                                    semester.name
                                }: ${semester.startDate.toLocaleShortDate()} - ${semester.endDate.toLocaleShortDate()}`}
                                tooltip={`Click to edit dates${
                                    semester.error
                                        ? ", these dates overlap with the previous range"
                                        : ""
                                }`}
                                theme={
                                    semester.error
                                        ? ButtonThemes.Bad
                                        : ButtonThemes.Normal
                                }
                                onClick={() =>
                                    this.props.onEditRange?.(semester)
                                }
                            />
                        ),
                    )}
                </GeneralContainer>
            </Panel>
        );
    }
}

export default TermDates;
